<ion-content class="permission-detail__content">
  <ion-button class="permission-detail__back" fill="clear" (click)="close()">
    <ion-icon name="arrow-back"></ion-icon>
  </ion-button>
  <div class="permission-detail__center">
    <div class="permission-detail__body">
      <div class="permission-detail__icon-wrapper">
        <ion-icon [name]="icon" class="permission-detail__icon"></ion-icon>
      </div>
      <p class="permission-detail__description">{{ fullDescription }}</p>
      <ion-button
        class="permission-detail__button"
        expand="block"
        color="success"
        (click)="openSettings()"
      >
        <ion-icon name="settings" slot="start"></ion-icon>
        {{ accessSettingsLabel }}
      </ion-button>
    </div>
  </div>
</ion-content>
